import { render, staticRenderFns } from "./CreateMaleAvatar.vue?vue&type=template&id=88cfa600&"
import script from "./CreateMaleAvatar.vue?vue&type=script&lang=js&"
export * from "./CreateMaleAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports